import gql from 'graphql-tag';

export const updateStoreByAdmin = gql`
  mutation updateStoreByAdmin($input: UpdateStoreInput){
    updateStoreByAdmin(input: $input){
      id
      name
      phone
      location
      email
      openHour
      closeHour
    }
  }
`;
